<template>
  <v-row justify="center">
    <v-dialog :value="confirmOpen" persistent max-width="325">      
      <v-card :color="color" dark>
        <v-card-title class="headline white--text" >{{ title }}</v-card-title>
        <v-card-text>{{ text }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>         
          <v-btn color="orange"   @click="onClose">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green"  @click="onConfirm">Confirm</v-btn>
        </v-card-actions>
      </v-card> 
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    props:['text', 'title', 'confirmOpen', 'color'],
    name:"ConfirmModal",
    data () {
      return {      
      }
    },
     methods: {
        onClose(){        
          this.$emit('cancelConfirm');
        },
        onConfirm(){
          this.$emit('confirm');
        }
    }  
  }
</script>